import React, { useCallback, useMemo, useState, useEffect } from 'react';
//import NumberFormat from 'react-number-format';
import {
  Button,
  Col,
  Dropdown,
  Grid,
  Image,
  Input,
  Menu,
  Modal,
  // Popover,
  Row,
  Select,
  Tooltip,
  Form,
  Space,
  Checkbox,
  Typography,
  DatePicker,
} from 'antd';
import {
  //CaretDownOutlined,
  CopyOutlined,
  EditOutlined,
  EllipsisOutlined,
  SearchOutlined,
  RedoOutlined
  //FileTextOutlined,
} from '@ant-design/icons';
import copy from 'copy-text-to-clipboard';
import theme from 'assets/styles/theme';
import { useHistory } from 'react-router-dom';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  DATAGRID_CACHE_INVENTORY_SEARCH_COLS,
  DATAGRID_CELL_ICON_WIDTH1,
  HTTP_STATUS_OK,
  LOADING_ICON_SIZE1,
  REGULAR_SECTION_INNER_VERTICAL_SPACING,
  // THUMBNAIL_REQUEST_SIZE1,
} from 'constants/config';
// import {
//   ExclamationCircleOutlined,
//   SettingFilled,
//   CaretDownOutlined,
// } from '@ant-design/icons';
import {
  /*DataGridPlus,*/
  ExportCSV,
  FormLabel,
  HeaderTitle,
  Loading,
  ScreenMask,
  SpaceCell,
  message,
  CopyComponent,
  TablesFilter,
} from 'components/common';
import DataGridPlus from 'components/common/DataGridPlus/DataGrid';
import { FormCol, GreyCardWrapper, GridIconBox, Label } from 'components/common/styles';
// import { fetchProductThumbnailUrl } from 'services/product';
import fallbackImage from 'assets/images/logo192.png';
import WarehouseSelectBox from '../Warehouse/WarehouseSelectBox';
import EditProductSKUDialog from './EditProductSKUDialog';
import EditProductTitleDialog from './EditProductTitleDialog';
import EditProductCodeDialog from './EditProductCodeDialog';
import EditProductPartNumberDialog from './EditProductPartNumberDialog';
import ProductDetailsDialog from './ProductDetail/ProductDetailsDialog';
import MoveItemDialog from './MoveItemDialog';
import { CenterBox, SearchListGridWrapper } from './style';
import EditProductQuantity from 'components/Inventory/Audit/EditProductQuantityDialog';
// import LocationProductsDialog from './LocationProductsDialog';
import { exportBusinessFile } from 'services/files';
import {
  clearWarehouseProductWithZeroInventory,
  fetchWarehouseProductList,
  syncToErp,
  syncToErp2,
} from 'services/inventory';
import AuditModal from './AuditModalDialog';
import {
  formatMessagewithBr,
  getWarehouseCodeFromCache,
  getPermissionValue,
  getProfileSettingValue,
  onSelectionChange,
} from 'utils'
import { userProfiles } from 'utils/auth';
import moment from 'moment'
import {skuTypeKeyValue, conditionEmun} from 'constants/enums'
import {
  getCustomers,
} from 'services/return';
import InputSkuListDialog from  '../Catalog/CatalogView/InputSkuListDialog'; 

const { Text } = Typography;
const { RangePicker } = DatePicker
/**
 * grid item types
 */
type ColumnRenderType = {
  data: InventoryProductRow;
};

export default function SearchList() {
  const DEFAULT_LIST_ROW_NUM = 30;
  //const DEFAULT_GRID_HEIGHT = 400;
  //const GRID_TOP_OFFSET = 214;

  //const [currentWarehouse, setCurrentWarehouse] = React.useState(-1);
  /**
   * This is a legacy state. Maybe it is needed in the future.
   */
  const [selectedWarehouseNums, setSelectedWarehouseNums] = React.useState<
    Array<number>
  >([]);
  const [selectedWarehouseIds, setSelectedWarehouseIds] = React.useState<
    Array<string>
  >([]);
  //const [gridHeight, setGridHeight] = React.useState(DEFAULT_GRID_HEIGHT);
  const [inited, setInited] = React.useState(false);
  const [isLoadingProductList, setIsLoadingProductList] = React.useState(false);
  const [isSearchingProductList, setIsSearchingProductList] =
    React.useState(false);
  const [lockScreen, setLockScreen] = useState(false);
  const [productSearchKeyword, setProductSearchKeyword] = React.useState('');
  const [productSearchType, setProductSearchType] = React.useState('SKU');
  //const [warehouseOptionValue, setWarehouseOptionValue] = React.useState('');
  //const [warehouseRawOptions, setWarehouseRawOptions] = React.useState<WarehouseOption[]>([]);
  const [paramLimit, setParamLimit] = React.useState(DEFAULT_LIST_ROW_NUM);
  const [paramSkip, setParamSkip] = React.useState(0);
  // const [paramSortBy /*setParamSortBy*/] = React.useState('ProductTitle');
  const [paramCalculateTotal /*setParamCalculateTotal*/] = React.useState(true);
  const [paramCount /*setParamCount*/] = React.useState(true);
  const [count, setCount] = React.useState(0);
  const [productList, setProductList] = React.useState<InventoryProductRow[]>(
    []
  );
  const [filteredData, setFilteredData] = React.useState<InventoryProductRow[]>(
    []
  );
  const [selected, setSelected] = useState<any>({});
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [skuType, setSkuType] = useState<any>();
  const [bundleType, setBundleType] = useState<-1 | 0 | 1>(-1);
  const [customerCode, setCustomerCode] = useState<any>();
  const [productStatus, setProductStatus] = React.useState<number>(0)
  const [productLoaded, setProductLoaded] = React.useState(false);
  const [totalSku, setTotalSku] = React.useState(0);
  const [totalLine, setTotalLine] = React.useState(0);
  const [totalQuantity, setTotalQuantity] = React.useState(0);
  const [totalBaseQty, setTotalBaseQty] = React.useState(0);
  //const [totalCost, setTotalCost] = React.useState(0);
  // maybe it is current selecting or editing product
  const [editingProduct, setEditingProduct] = React.useState<ProductRow>({
    id: 0,
    productId: '',
  });
  const [warehouseSelectBoxWidth, setWarehouseSelectBoxWidth] =
    React.useState(20);
  const [currentProduct, setCurrentProduct] =
    React.useState<any>();
  const sortString = React.useRef('sku asc');
  const [qty, setQty] = useState<number>();
  // const [qtyValue, setQtyValue] = useState<number>();
  const [geLe, setGeLe] = useState<string>('le');
  const [editProductQuantityVisible, setEditProductQuantityVisible] =
    useState(false);
  // const [locationProductsVisible, setLocationProductsVisible] = useState(false);
  const [hideZero, setHideZero] = useState<boolean>(true);
  const [firstIn, setFirstIn] = useState<any>();
  const [expiration, setExpiration] = useState<any>();
  // eslint-disable-next-line
  const [syncing, setSyncing] = useState<boolean>(false);
  const [customers, setCustomers] = useState<any[]>([]);
  const [auditModalVisible, setAuditModalVisible] = useState(false);
  const [lotEnable, setLotEnable] = useState(false);
  const [uomEnable, setUomEnable] = useState(false);
  const [enableSnapShotSync, setEnableSnapShotSync] = useState(false);
  const [showCondition, setShowCondition] = useState(false)
  const [setttingInited, setSettingInited] = useState(false)
  const [listSkuInputVisible, setListSkuInputVisible] = useState(false);


  /**
   * The screen size type.
   */
  const screens = Grid.useBreakpoint();
  const history = useHistory();

  const enableSN = userProfiles.getProfileSettingValue('EnableProductSerialNumber') === '1';

  const [productSKUDialogVisible, setProductSKUDialogVisible] =
    useState<boolean>(false);
  const [productCodeDialogVisible, setProductCodeDialogVisible] =
    useState<boolean>(false);
  const [productPartNumberDialogVisible, setProductPartNumberDialogVisible] =
    useState<boolean>(false);
  const [productDetailsDialogVisible, setProductDetailsDialogVisible] =
    useState<boolean>(false);

  const [editProductTitleDialogVisible, setProductTitleDialogVisible] =
    useState<boolean>(false);

  const [moveItemDialogVisible, setMoveItemDialogVisible] =
    useState<boolean>(false);

  // const [thumbnailDict, setThumbnailDict] = useState<{ [key: number]: string }>(
  //   {}
  // );

  const showProductSKUDialog = useCallback((visible: boolean) => {
    setProductSKUDialogVisible(visible);
  }, []);

  const showProductPartNumberDialog = useCallback((visible: boolean) => {
    setProductPartNumberDialogVisible(visible);
  }, []);

  const showProductCodeDialog = useCallback((visible: boolean) => {
    setProductCodeDialogVisible(visible);
  }, []);

  const showProductDetailsDialog = useCallback((visible: boolean) => {
    setProductDetailsDialogVisible(visible);
  }, []);
  const showProductTitleDialog = useCallback((visible: boolean) => {
    setProductTitleDialogVisible(visible);
  }, []);
  const showMoveItemDialog = useCallback((visible: boolean) => {
    setMoveItemDialogVisible(visible);
  }, []);

    const getProfileSetting = useCallback(async()=>{
      const res1 = await getProfileSettingValue('EnableLOT', '0')
      const res2 = await getProfileSettingValue('EnableUOM','0')
      const res3 = await getProfileSettingValue('ShowProductCondition','0')
      const res4 = await getProfileSettingValue('EnableInentorySync','0')
      const imp = await getPermissionValue(40005);
      setLotEnable(res1 === '1')
      setUomEnable(res2 === '1')
      setShowCondition(res3 === '1')
      setEnableSnapShotSync(res4 === '1' && imp === 4)
      setSettingInited(true)
    },[])
  
    useEffect(()=>{
      getProfileSetting()
    },[getProfileSetting])

  /**
   * Clear the product search state data.
   * When switch the warehouse, it needs to set these search data to initial state.
   */
  const clearProductSearchData = () => {
    setProductSearchType('SKU');
    setProductSearchKeyword('');
    setIsSearchingProductList(false);
  };

  const clearZeroInventory = () => {
    if (isSearchingProductList) {
      return;
    }

    if (selectedWarehouseNums.length === 0) {
      message.error({
        content: 'Please select a warehouse.',
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    }

    if (!productSearchType) {
      if (productSearchKeyword) {
        message.error({
          content: 'Please select a product type.',
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
        return;
      } else {
        clearProductWithZeroInventory(
          selectedWarehouseNums[0],
          selectedWarehouseIds[0],
          paramSkip,
          paramLimit
        );
        return;
      }
    }

    let filter = getProductSearchFilter(
      productSearchType,
      productSearchKeyword
    );
    const title =
      productSearchType === 'ProductTitle' ? productSearchKeyword : '';

    clearProductWithZeroInventory(
      selectedWarehouseNums[0],
      selectedWarehouseIds[0],
      paramSkip,
      paramLimit,
      filter,
      title
    );
  };

  const clearProductWithZeroInventory = async (
    warehouseNum: number,
    warehouseId: string,
    skip: number,
    top: number,
    filter?: string | StringKAnyVPair,
    title?: string,
  ) => {
    let query: StringKAnyVPair = {
      $skip: skip,
      $top: top,
      $sortBy: sortString.current,
      $calculateTotal: paramCalculateTotal,
      $count: paramCount,
    };

    /*if (!title && filter) {
      query.$filter = filter;
    }*/
    if (!title && filter) {
        const filterType = typeof filter;

        if (filterType === 'string') {
          query.$filter = filter;
        } else if (filterType === 'object') {
          // @ts-ignore
          for (const k in filter) {
            // @ts-ignore
            query[k] = filter[k];
          }
        }
      }
    if (title) {
      query.title = title;
    }
    if (productSearchType === 'SKU' && productSearchKeyword) {
      query.uniqueCode = productSearchKeyword;
    }
    if (qty || qty === 0) {
      query.qty = geLe === 'le'
        ? `le ${qty}`
        : geLe === 'ge'
          ? `ge ${qty}`
          : `eq ${qty}`
    }
    if (productStatus > -1) {
      query.productStatus = productStatus;
    }
    if (
      [
        'skuStartsWith',
        'divisionCode',
        'departmentCode',
        'groupCode',
        'subGroupCode',
        'productTitleContains',
        'lotNumber',
        'skus',
      ].includes(productSearchType)
    ) {
      query[productSearchType] = productSearchKeyword;
      delete query.$filter;
    }

    query.hideZero = hideZero ? true : false;
    query.thumbnailSize = 50;

    // console.log(firstIn)

    query.firstIn_from = firstIn ? moment(firstIn[0]).startOf('days').format() : undefined;
    query.firstIn_to = firstIn ? moment(firstIn[1]).endOf('days').format() : undefined;
    query.expiration_from = expiration ? moment(expiration[0]).startOf('days').format() : undefined;
    query.expiration_to = expiration ? moment(expiration[1]).endOf('days').format() : undefined;

    query.customerCode = customerCode? customerCode: undefined;
    query.skuType = skuType || skuType === 0 ? skuType : undefined;
    query.bundleType  = bundleType >= 0 ? bundleType : undefined;

    setLockScreen(true);
    try {
      const { code, data } = await clearWarehouseProductWithZeroInventory(warehouseId, query) as any;

      if (code === HTTP_STATUS_OK) {
        if (data && typeof data === 'string') {
          message.info({
            content: data,
            duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
          });
        }
      }
    } catch(e) {
      message.error({
        content: `Cleared error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setLockScreen(false);
    }
  };

  const createMoreActionButton = () => {
    return (
      <Dropdown
        arrow
        overlay={(
          <Menu>
            <Menu.Item disabled={filteredData.length === 0} key="clear-0-inv-menu" onClick={clearZeroInventory}>
              Clear 0 inventory in the search result
            </Menu.Item>
          </Menu>
        )}
      >
        <Button>
          More
          <EllipsisOutlined />
        </Button>
      </Dropdown>
    );
  };

  const deselectGridRows = () => {
    setSelected({});
    setSelectedRows([]);
  };

  /**
   * Get the product filter. The filter is like sku cn 'xxx'.
   *
   * @return {string}
   */
  const getProductSearchFilter = (type: string, keyword: string) => {
    const keys = ['serialNumber'];
    let filter: string | StringKAnyVPair = '';

    if (keys.indexOf(type) > -1) {
      filter = {[type]: keyword};
    } else if (type && keyword) {
      filter =
        type === 'SKU'
          ? // ? `(SKU eq '${keyword}' or UPC eq '${keyword}' or FNSKU eq '${keyword}' or EAN eq '${keyword}')`
          ''
          : type === 'skuStartsWith'
            // : type === 'skuStartsWith'
            ? `SKU cn '${keyword}'`
            : `${type} cn '${keyword}'`;
    }

    return filter;
  };

  const getCustomerInfo = useCallback(async () => {
    try {
      const res = await getCustomers()
      if (res.isSuccess) {
        setCustomers(res.data)
      }
    } catch (error) {
    }
  }, [])

  useEffect(() => {
    getCustomerInfo()
  }, [getCustomerInfo])

  /**
   * Get the product thumbnail;
   */
  // const getProductThumbnail = async (productId: string) => {
  //   return await fetchProductThumbnailUrl(productId, THUMBNAIL_REQUEST_SIZE1);
  // };

  /**
   * Get the product list for selected warehouses.
   *
   * @param {number} warehouseId - the id of warehouse, note: 0 is all warehouses
   * @param {?string} filter - SQL filter
   */
  const getWarehouseProductList = React.useCallback(
    async (
      warehouseNum: number,
      warehouseId: string,
      skip: number,
      top: number,
      filter?: string | StringKAnyVPair,
      title?: string
    ) => {
      let query: StringKAnyVPair = {
        $skip: skip,
        $top: top,
        $sortBy: sortString.current,
        $calculateTotal: paramCalculateTotal,
        $count: paramCount,
      };

      if (!title && filter) {
        const filterType = typeof filter;

        if (filterType === 'string') {
          query.$filter = filter;
        } else if (filterType === 'object') {
          // @ts-ignore
          for (const k in filter) {
            // @ts-ignore
            query[k] = filter[k];
          }
        }
      }
      if (title) {
        query.title = title;
      }
      if (productSearchType === 'SKU' && productSearchKeyword) {
        query.uniqueCode = productSearchKeyword;
      }
      if (qty || qty === 0) {
        query.qty = geLe === 'le'
          ? `le ${qty}`
          : geLe === 'ge'
            ? `ge ${qty}`
            : `eq ${qty}`
      }
      if (productStatus > -1) {
        query.productStatus = productStatus;
      }
      if (
        [
          'skuStartsWith',
          'divisionCode',
          'departmentCode',
          'groupCode',
          'subGroupCode',
          'productTitleContains',
          'lotNumber',
          'skus',
        ].includes(productSearchType)
      ) {
        query[productSearchType] = productSearchKeyword;
        delete query.$filter;
      }

      query.hideZero = hideZero ? true : false;
      query.thumbnailSize = 50;

      // console.log(firstIn)

      query.firstIn_from = firstIn ? moment(firstIn[0]).startOf('days').format() : undefined;
      query.firstIn_to = firstIn ? moment(firstIn[1]).endOf('days').format() : undefined;
      query.expiration_from = expiration ? moment(expiration[0]).startOf('days').format() : undefined;
      query.expiration_to = expiration ? moment(expiration[1]).endOf('days').format() : undefined;

      query.customerCode = customerCode? customerCode: undefined;
      query.skuType = skuType || skuType === 0 ? skuType : undefined;
      query.bundleType  = bundleType >= 0 ? bundleType : undefined;

      let products;

      setIsLoadingProductList(true);
      deselectGridRows();

      try {
        products = await fetchWarehouseProductList(warehouseId, query);
        setIsLoadingProductList(false);
      } catch (e) {
        setIsLoadingProductList(false);
        return;
      }

      if (products && 'object' === typeof products) {
        const dataLength = (Array.isArray(products.data) && products.data.length > 0) ? products.data.length : 0;
        // let thumbDict: { [key: number]: string } = {};
        setProductLoaded(true);
        //setTotalCost(products.totalCost);
        setTotalLine(dataLength > 0 ? products.count : 0);
        setTotalBaseQty(dataLength > 0 ? products.totalBaseQty : 0);
        setTotalQuantity(dataLength > 0 ? products.totalQuantity : 0);
        setTotalSku(dataLength > 0 ? products.totalSku : 0);
        // setThumbnailDict({});
        setCount(products.count);
        setProductList(
          products.data.map((e: any, i: number) => {
            let product = {
              id: i,
              code: 'code',
              warehouseId: warehouseId,
              sku: e.sku,
              upc: e.upc,
              title: e.productTitle,
              picture: e.pictureUrl,
              productTitle: e.productTitle,
              locationCode: e.locationCode,
              locationId: e.locationId,
              locationNum: e.locationNum,
              lotNumber: e.lotNumber,
              warehouseCode: e.warehouseCode,
              warehouseNum: e.warehouseNum,
              quantity: e.quantity,
              partNumber: e.partNumber,
              productNum: e.fulfillmentProductNum,
              productId: e.productId,
              divisionCode: e.divisionCode,
              departmentCode: e.departmentCode,
              groupCode: e.groupCode,
              subGroupCode: e.subGroupCode,
              thumbnailUrl: e.thumbnailUrl,
              productStatus: e.productStatus,
              uom: e.uom,
              uomBaseQty: e.uomBaseQty,
              uomRate: e.uomRate,
              condition: e.condition,
            };

            // if (
            //   !thumbDict[product.productNum] &&
            //   product.productNum > 0 &&
            //   product.productId
            // ) {
            //   getProductThumbnail(product.productId).then((e) => {
            //     if (e && 'string' === typeof e) {
            //       thumbDict[product.productNum] = e;
            //       setThumbnailDict({ ...thumbDict });
            //     }
            //   });
            //   thumbDict[product.productNum] = 'error';
            // }

            return product;
          })
        );
      }
    },
    [
      //getProductSearchFilter,
      //isSearchingProductList,
      // paramSkip,
      // paramTop,
      productSearchKeyword,
      productSearchType,
      productStatus,
      paramCalculateTotal,
      paramCount,
      geLe,
      qty,
      hideZero,
      firstIn,
      expiration,
      customerCode,
      skuType,
      bundleType
    ]
  );

  /**
   * Make the warehouse select box grid width.
   */
  const getWarehouseSearchBoxWidth = React.useCallback(() => {
    let width = 20;

    if (screens.lg) {
      width = 18;
    } else if (screens.md) {
      width = 11;
    } else if (screens.xs || screens.sm) {
      width = 11;
    }

    //setWarehouseSelectBoxWidth(width);
    return width;
  }, [screens]);

  /**
   * Search product list handler.
   */
  const handleSearchProduct = React.useCallback(async () => {
    if (isSearchingProductList) {
      return;
    }

    //console.log(searchStr, evt, evt.currentTarget.tagName);
    // if (!force && 'INPUT' === evt.currentTarget.tagName) {
    //   return;
    // }

    if (selectedWarehouseNums.length === 0) {
      message.error({
        content: 'Please select a warehouse.',
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    }

    if (!productSearchType) {
      if (productSearchKeyword) {
        message.error({
          content: 'Please select a product type.',
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
        return;
      } else {
        getWarehouseProductList(
          selectedWarehouseNums[0],
          selectedWarehouseIds[0],
          0,
          paramLimit
        );
        return;
      }
    }

    let filter = getProductSearchFilter(
      productSearchType,
      productSearchKeyword
    );
    const title =
      productSearchType === 'ProductTitle' ? productSearchKeyword : '';
    //console.log('handle search', title, filter);
    setIsSearchingProductList(true);
    await getWarehouseProductList(
      selectedWarehouseNums[0],
      selectedWarehouseIds[0],
      0,
      paramLimit,
      filter,
      title
    );
    setIsSearchingProductList(false);
  }, [
    getWarehouseProductList,
    isSearchingProductList,
    paramLimit,
    productSearchType,
    selectedWarehouseNums,
    selectedWarehouseIds,
    productSearchKeyword,
  ]);

  /**
   * Handle warehouse selection.
   * The related state(selectedWarehouseIds) will be updated.
   * @param {number|Array<number>} If the warehouse is an array, it indicates that you can select more than one warehouse at a time.
   */
  const handleWarehouseCodeChange = (
    value: number | Array<number>,
    opt: any
  ) => {
    if ('number' === typeof value) {
      setSelectedWarehouseNums([value]);
      setSelectedWarehouseIds([opt.warehouseId]);
    } else {
      setSelectedWarehouseNums(value);
      setSelectedWarehouseIds(opt.warehouseId);
    }

    clearProductSearchData();
    // Note: if value is an array, the way of passing parameters needs to be changed
    //getWarehouseProductList(value as number, 0, 10);
  };

  // eslint-disable-next-line
  const isSyncButtonEnabled = () => {
    return filteredData.length > 0;
  };

  /**
   * The callback for editing title of product.
   * Note: the properties of parameter product must be the same with type InventoryProductRow
   *
   * @param {number} id - the product id
   * @param {[key: string]: string} - some properties for the product
   */
  const onEditProduct = (id: number, product: StringKVPair) => {
    let list = [];

    for (let i = 0; i < productList.length; i++) {
      list.push(productList[i]);

      if (productList[i].productNum === id) {
        list[i] = {
          ...list[i],
          ...product,
        };
      }
    }

    setProductList(list);
  };

  /**
   * download all data
   */
  const downLoadAll = useCallback(
    async (SelectField, groupBy) => {
      const skuList = Array.isArray(SelectField.skuList) ? SelectField.skuList : undefined;
        
      if (Array.isArray(SelectField.skuList)) {
        delete SelectField.skuList;
      }

      setLockScreen(true);

      try {
        const job = await exportBusinessFile(4, {
          FilterCondition: {
            warehouseId: selectedWarehouseIds[0],
            locationCode:
              productSearchType === 'LocationCode' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            skuStartsWith:
              productSearchType === 'skuStartsWith' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            serialNumber:
              productSearchType === 'serialNumber' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            productTitleContains:
              productSearchType === 'productTitleContains' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            divisionCode:
              productSearchType === 'divisionCode' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            departmentCode:
              productSearchType === 'departmentCode' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            groupCode:
              productSearchType === 'groupCode' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            subGroupCode:
              productSearchType === 'subGroupCode' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            lotNumber:
              productSearchType === 'lotNumber' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            uniqueCode:
              productSearchType === 'SKU' && productSearchKeyword
                ? productSearchKeyword
                : undefined,
            uniqueCodeList: productSearchType === 'skus' && productSearchKeyword ? productSearchKeyword : undefined,

            // qty:
            //   qty > 0 ? (geLe === 'le'
            //     ? `le ${qty}`
            //     : geLe === 'ge'
            //       ? `ge ${qty}`
            //       : `eq ${qty}`) : undefined,

            qty: (qty || qty === 0) ? geLe === 'le'
              ? `le ${qty}`
              : geLe === 'ge'
                ? `ge ${qty}`
                : `eq ${qty}` : undefined,
            productStatus: productStatus > -1 ? productStatus : undefined,
            hideZero: hideZero ? true : false,
            firstIn_from : firstIn ? moment(firstIn[0]).startOf('days').format() : undefined,
            firstIn_to : firstIn ? moment(firstIn[1]).endOf('days').format() : undefined,
            expiration_from : expiration ? moment(expiration[0]).startOf('days').format() : undefined,
            expiration_to : expiration ? moment(expiration[1]).endOf('days').format() : undefined,
            customerCode: customerCode? customerCode: undefined,
            skuType: skuType || skuType === 0 ? skuType : undefined,
            skus: skuList,
            bundleType: bundleType >= 0 ? bundleType : undefined
          },
          SelectField,
          OrderByField: sortString.current,
          GroupByField: groupBy || '',
        });
        if (job.jobguid && job.systemfilename) {
          Modal.confirm({
            title: 'Job has been generated',
            okText: 'Close',
            cancelText: 'Check now',
            centered: true,
            content:
              'Job in progress, you can check the job status in the export menu on the left side later.',
            onOk() { },
            onCancel() {
              history.push('/export');
            },
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLockScreen(false);
      }
    },
    [
      geLe,
      selectedWarehouseIds,
      history,
      productSearchKeyword,
      productSearchType,
      productStatus,
      qty,
      hideZero,
      expiration,
      firstIn,
      skuType,
      customerCode,
      bundleType
    ]
  );

  // eslint-disable-next-line
  const syncInventoryToErp = useCallback(async ()=>{
    try {
      setSyncing(true)
      const warehouseCode = getWarehouseCodeFromCache(selectedWarehouseNums[0])
      //const skus = filteredData.map(e => e.sku);
      const res = await syncToErp({warehouseCode})
      //const res = await syncToErp2({warehouseCode, skus})
      setSyncing(false)
      if(res.isSuccess){
        message.success({content: formatMessagewithBr(res.message) || 'Sync Successfully'})
      }
    } catch (error) {
      setSyncing(false)
    }
  },[selectedWarehouseNums])

  const syncSkuToErp = async () => {
    try {
      setLockScreen(true)
      const warehouseCode = getWarehouseCodeFromCache(selectedWarehouseNums[0])
      const skus = selectedRows.map(e => e.sku);
      //const res = await syncToErp({warehouseCode})
      const res = await syncToErp2({warehouseCode, skus})
      //setSyncing(false)
      //console.log('r', skus, res);
      if (res.isSuccess){
        message.success({content: formatMessagewithBr(res.message) || 'Sync Successfully'})
      }
    } catch (error) {
      //setSyncing(false)
    } finally {
      setLockScreen(false);
    }
  };

  const syncWHToErp = async () => {
    try {
      setLockScreen(true)
      const warehouseCode = getWarehouseCodeFromCache(selectedWarehouseNums[0])
      const res = await syncToErp2({warehouseCode})
      //setSyncing(false)
      //console.log('r', skus, res);
      if (res.isSuccess){
        message.success({content: formatMessagewithBr(res.message) || 'Sync Successfully'})
      }
    } catch (error) {
      //setSyncing(false)
    } finally {
      setLockScreen(false);
    }
  };

  /**
   * Refresh the product list. It is often used as a callback while modify a product.
   */
  const refreshProductList = async () => {
    if (selectedWarehouseNums.length === 0) {
      return;
    }

    let filter = getProductSearchFilter(
      productSearchType,
      productSearchKeyword
    );
    setIsLoadingProductList(true);
    await getWarehouseProductList(
      selectedWarehouseNums[0],
      selectedWarehouseIds[0],
      paramSkip,
      paramLimit,
      filter
    );
    setIsLoadingProductList(false);
  };

  const StatisticColumns = () => {
    const columns = [
      { label: 'Total SKUs', total: totalSku },
      { label: 'Total Lines', total: totalLine },
      { label: 'Total Quantity', total: totalQuantity },
      /*
      {
        label: "Total Cost",
        total: (
          <NumberFormat
            value={totalCost}
            decimalScale={2}
            fixedDecimalScale={true}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        ),
      },
      */
    ];

    if (uomEnable) {
      columns.push({ label: 'Total Base Quantity', total: totalBaseQty });
    }

    return (
      <Space split="|" size="large">
        {columns.map((col, i) => (
          <CenterBox key={`statistic_col_${i}`}>
            <Label>
              {col.label}: <span className="label-grey">{col.total}</span>
            </Label>
          </CenterBox>
        ))}
      </Space>
    );
  };

  const onClickSkuCell = useCallback((data: StringKAnyVPair) => {
    const selObj = window.getSelection();
    let open = selObj && selObj.toString() ? false : true;

    if (open) {
      setEditingProduct({
        id: data.productNum,
        productId: data.productId,
      });
      showProductDetailsDialog(true);
    }
  }, [showProductDetailsDialog]);

  const columns = useMemo(() => {
    const cls = [
      {
        minWidth: 220,
        name: 'sku',
        header: 'SKU',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        render: (value: ColumnRenderType) => {
          const { data } = value;

          return (
            <SpaceCell
              icon={
                <Tooltip
                  placement="top"
                  title="Copy"
                  trigger={['hover', 'click']}
                >
                  <CopyOutlined
                    onClick={() => {
                      copy(data.sku);
                      message.info(`"${data.sku}" has been copied to clipboard`);
                    }}
                    style={{ color: theme['@info-color'] }}
                  />
                </Tooltip>
              }
              iconWidth={DATAGRID_CELL_ICON_WIDTH1}
              onTextClick={() => onClickSkuCell(data)}
              text={data.sku}
              textIsButton
            />
          );
        },
      },
      {
        minWidth: 200,
        name: 'upc',
        header: 'UPC',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        needToolTip: true,
        // render: (value: ColumnRenderType) => {
        //   const { data } = value;

        //   return (
        //     <Popover placement="topLeft" content={data.upc}>
        //       {data.upc}
        //     </Popover>
        //   );
        // },
      },
      {
        minWidth: 130,
        name: 'lotNumber',
        header: 'LOT#',
        defaultFlex: 1,
        lotColumn: true,
        userSelect: true,
      },
      {
        minWidth: 130,
        name: 'warehouseCode',
        header: 'Warehouse',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
      },
      {
        minWidth: 120,
        name: 'locationCode',
        header: 'Location',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        render: (value: ColumnRenderType) => {
          const { data } = value;
          return (
            <CopyComponent value={data.locationCode}>
              <Text
                underline
                ellipsis={{ tooltip: data.locationCode }}
                style={{ cursor: 'pointer', width: `calc(100% - 14px)` }}
                onClick={() => {
                  setCurrentProduct(data);
                  setAuditModalVisible(true);
                }}
              >
                {data.locationCode}
              </Text>
            </CopyComponent>

            // <>
            //   <Tooltip
            //     placement="top"
            //     title={data.locationCode}
            //     // trigger={['hover', 'click']}
            //   >
            //     {data.locationCode}
            //   </Tooltip>

            //   <GridIconBox>
            //     <EditOutlined
            //       onClick={() => {
            //         setCurrentProduct(data);
            //         setLocationProductsVisible(true);
            //       }}
            //     />
            //   </GridIconBox>
            // </>
          );
        },
      },
      {
        minWidth: 120,
        name: 'zoneName',
        header: 'Zone',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        needToolTip: true,
        // render: (value: ColumnRenderType) => {
        //   const { data } = value;
        //   return (
        //     <Tooltip
        //       placement="top"
        //       title={data.zoneName}
        //       // trigger={['hover', 'click']}
        //     >
        //       {data.zoneName}
        //     </Tooltip>
        //   );
        // },
      },
      {
        minWidth: 120,
        name: 'quantity',
        header: 'Quantity',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        type: 'number',
        sort: (a: number, b: number) => a - b,
        render: (value: ColumnRenderType) => {
          const { data } = value;
          return (
            <>
              {data.quantity}
              <GridIconBox>
                <EditOutlined
                  onClick={() => {
                    setCurrentProduct(data);
                    setEditProductQuantityVisible(true);
                  }}
                />
              </GridIconBox>
            </>
          );
        },
      },
      {
        minWidth: 130,
        name: 'uom',
        header: 'UOM',
        defaultFlex: 1,
        uomColumn: true,
        userSelect: true,
      },
      {
        minWidth: 130,
        name: 'uomRate',
        header: 'UOM Rate',
        defaultFlex: 1,
        uomColumn: true,
        userSelect: true,
      },
      {
        minWidth: 130,
        name: 'uomBaseQty',
        header: 'Base Qty',
        defaultFlex: 1,
        uomColumn: true,
        userSelect: true,
      },
      {
        minWidth: 200,
        name: 'divisionCode',
        header: 'Division Code',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        needToolTip: true,
        // render: (value: ColumnRenderType) => {
        //   const { data } = value;
        //   return (
        //     <Popover placement="topLeft" content={data.divisionCode}>
        //       {data.divisionCode}
        //     </Popover>
        //   );
        // },
      },
      {
        minWidth: 270,
        name: 'productTitle',
        header: 'Product Name',
        defaultFlex: 1,
        userSelect: true,
        needToolTip: false,
      },
      {
        minWidth: 120,
        name: 'productStatus',
        header: 'Product Status',
        defaultFlex: 1,
        userSelect: true,
        renderEnum: {
          0: 'Active',
          1: 'Archive'
        },
        render: (row: any) => {
          const { data } = row;
          const map = {
            0: 'Active',
            1: 'Archive'
          }
          return (
            // @ts-ignore
            <CopyComponent value={map[data.productStatus]}>
              {/* @ts-ignore */}
              <Text>{map[data.productStatus]}</Text>
            </CopyComponent>
          )
        }
      },
      {
        minWidth: 200,
        name: 'departmentCode',
        header: 'Department Code',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        needToolTip: true,
        // render: (value: ColumnRenderType) => {
        //   const { data } = value;

        //   return (
        //     <Popover placement="topLeft" content={data.departmentCode}>
        //       {data.departmentCode}
        //     </Popover>
        //   );
        // },
      },
      {
        minWidth: 200,
        name: 'groupCode',
        header: 'Group Code',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        needToolTip: true,
        // render: (value: ColumnRenderType) => {
        //   const { data } = value;

        //   return (
        //     <Popover placement="topLeft" content={data.groupCode}>
        //       {data.groupCode}
        //     </Popover>
        //   );
        // },
      },
      {
        minWidth: 200,
        name: 'subGroupCode',
        header: 'Subgroup Code',
        // headerAlign: 'center' as 'center',
        defaultFlex: 1,
        userSelect: true,
        needToolTip: true,
      },
      {
        minWidth: 100,
        name: 'thumbnailUrl',
        header: 'Picture',
        showColumnMenuTool: false,
        groupBy: false,
        defaultFlex: 1,
        resizable: false,
        sortable: false,
        // maxWidth: 100,
        // minWidth: 100,
        textAlign: 'center',
        textVerticalAlign: 'middle',
        // renderHeader: () => 'Picture',
        render: (value: ColumnRenderType) => {
          const { data } = value;
          const { thumbnailUrl = '' } = data;
          if (thumbnailUrl) {
            return <Image
              width={32}
              height={32}
              preview={false}
              // src={thumbnailDict[data.productNum] || 'error'}
              src={data.thumbnailUrl}
              fallback={fallbackImage}
              style={{ cursor: 'pointer' }}
            />
          }
        },
      },
      {
        name: 'condition',
        header: 'Condition',
        defaultFlex: 1,
        userSelect: true,
        sortable: false,
        conditionColumn: true,
        render: (row: any) => {
          return conditionEmun[`${row.data.condition || 0}`];
        }
      },
    ];
    let temp = [...cls]
    temp = lotEnable ? [...temp] : temp.filter(i => !i.lotColumn)
    temp = uomEnable ? [...temp] : temp.filter(i => !i.uomColumn)
    temp = showCondition ? [...temp] : temp.filter(i => !i.conditionColumn)
    return temp;
  }, [lotEnable, uomEnable, onClickSkuCell, showCondition])


  React.useEffect(() => {
    if (!inited) {
      /*let height = window.innerHeight - GRID_TOP_OFFSET - 6;

      height = height <= DEFAULT_GRID_HEIGHT ? DEFAULT_GRID_HEIGHT : height;

      setGridHeight(height - 36);*/
      //console.log('ss', Object.keys(skuTypeKeyValue).map(val => ({k: skuTypeKeyValue[val], v: val})).sort((a, b) => a.k.localeCompare(b.k)), skuTypeKeyValue);
      setInited(true);
    }

    const width = getWarehouseSearchBoxWidth();

    if (width !== warehouseSelectBoxWidth) {
      setWarehouseSelectBoxWidth(width);
    }
  }, [getWarehouseSearchBoxWidth, inited, warehouseSelectBoxWidth]);

  // const formItemLayout = {
  //   labelCol: {
  //     xs: { span: 24 },
  //     sm: { span: 7 },
  //   },
  //   wrapperCol: {
  //     xs: { span: 24 },
  //     sm: { span: 20 },
  //   },
  // };
  return (<>
    <SearchListGridWrapper className="common-hcontent-box">
      <Row justify="end">
        <EditProductSKUDialog
          product={editingProduct}
          visible={productSKUDialogVisible}
          onHide={() => showProductSKUDialog(false)}
        />
        <EditProductCodeDialog
          product={editingProduct}
          visible={productCodeDialogVisible}
          onHide={() => showProductCodeDialog(false)}
        />
        <EditProductPartNumberDialog
          product={editingProduct}
          visible={productPartNumberDialogVisible}
          onHide={() => showProductPartNumberDialog(false)}
        />
        {editingProduct && productDetailsDialogVisible && (
          <ProductDetailsDialog
            productId={editingProduct.productId}
            visible={productDetailsDialogVisible}
            onHide={() => showProductDetailsDialog(false)}
          />
        )}
        {editProductTitleDialogVisible && (
          <EditProductTitleDialog
            product={editingProduct}
            visible={true}
            onSuccess={onEditProduct}
            onHide={() => showProductTitleDialog(false)}
          />
        )}
        {/* {currentProduct && locationProductsVisible && (
          <LocationProductsDialog
            visible
            onHide={() => setLocationProductsVisible(false)}
            product={currentProduct}
            warehouseId={selectedWarehouseIds[0]}
          />
        )} */}
        {currentProduct && auditModalVisible && (
          <AuditModal
            product={currentProduct}
            visible={true}
            onClose={() => setAuditModalVisible(false)}
          />
        )}
        {currentProduct && editProductQuantityVisible && (
          <EditProductQuantity
            onHide={() => setEditProductQuantityVisible(false)}
            onSuccess={() => {
              setEditProductQuantityVisible(false);
              refreshProductList();
            }}
            warehouseId={`${currentProduct.warehouseId}`}
            locationId={currentProduct.locationId}
            product={currentProduct}
            uomEnable={uomEnable}
            lotEnable={lotEnable}
          />
        )}
        {currentProduct && moveItemDialogVisible ? (
          <MoveItemDialog
            product={currentProduct}
            visible={moveItemDialogVisible}
            onSuccess={refreshProductList}
            onHide={() => showMoveItemDialog(false)}
          />
        ) : (
          ''
        )}
      </Row>
      <HeaderTitle breadcrumb={['Inventory', 'Search']}>
        <Space>
          {enableSnapShotSync && (
            <div className="ant-input-group-wrapper bblr-10 btlr-10 w-none">
              {/*<Button disabled={!isSyncButtonEnabled()} loading={syncing} icon={<RedoOutlined />} onClick={()=>syncInventoryToErp()}>
                Sync Inventory to ERP
              </Button>*/}
              <Dropdown
                overlay={(
                  <Menu>
                    {/*<Menu.Item disabled={selectedRows.length === 0} key="sync-batch-btn" onClick={() => syncSkuToErp()}>
                      <Label >
                        <RedoOutlined />
                        &nbsp;Sync SKUs to ERP
                      </Label>
                    </Menu.Item>*/}
                    <Menu.Item disabled={selectedWarehouseNums.length === 0} key="sync-wh-btn" onClick={() => syncWHToErp()}>
                      <Label >
                        <RedoOutlined />
                        &nbsp;Sync whole warehouse
                      </Label>
                    </Menu.Item>
                    <Menu.Item disabled={selectedRows.length === 0} key="sync-wh-sku-btn" onClick={() => syncSkuToErp()}>
                      <Label >
                        <RedoOutlined />
                        &nbsp;Sync selected SKUs
                      </Label>
                    </Menu.Item>
                  </Menu>
                )}
              >
                <Button className="p-4-10">
                  <RedoOutlined />
                  Sync Inventory to ERP
                </Button>
              </Dropdown>
            </div>
          )}
        </Space>
      </HeaderTitle>
      <GreyCardWrapper>
        <Form>
          <Row>
            <Col>
              <Form.Item label={<FormLabel>Warehouse</FormLabel>}>
                <div style={{ paddingRight: 10, minWidth: 150 }}>
                  <WarehouseSelectBox
                    onChange={handleWarehouseCodeChange}
                    onlyNormal={false}
                  />
                </div>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item style={{ marginRight: '20px' }} label={<FormLabel>Qty</FormLabel>}>
                <Input
                  style={{ width: '150px' }}
                  value={qty}
                  onChange={(e) => {
                    e.persist();
                    if(e.target.value){
                      const iptVal = Number(e.target.value);
                      if(isNaN(iptVal)){
                        setQty(undefined)
                      } else {
                        setQty(iptVal)
                      }
                    } else {
                      setQty(undefined)
                    }

                  }}
                  type="number"
                  min={0}
                  addonBefore={
                    <Select
                      defaultValue="le"
                      dropdownMatchSelectWidth={false}
                      // style={{ width: 70 }}
                      onChange={(value: string) => setGeLe(value)}
                    >
                      <Select.Option value="le">{'<='}</Select.Option>
                      <Select.Option value="ge">{'>='}</Select.Option>
                      <Select.Option value="eq">{'='}</Select.Option>
                    </Select>
                  }
                />
              </Form.Item>
            </Col>

            <FormCol>
              <Form.Item
                labelCol={{ style: { width: '200px', display: 'flex', flexDirection: 'row' } }}
                label={
                  <Select
                    className="group-compact-select-left form-selection200"
                    dropdownMatchSelectWidth={false}
                    disabled={selectedWarehouseNums.length === 0}
                    onChange={(val) => {
                      setProductSearchType(val as string);
                      setProductSearchKeyword('');
                    }}
                    value={productSearchType}
                  >
                    <Select.Option value="LocationCode">Location</Select.Option>
                    <Select.Option value="SKU">SKU / UPC / Code equals</Select.Option>
                    {/* <Select.Option value="SKUContains">
                      SKU starts with
                    </Select.Option> */}
                    <Select.Option value="skuStartsWith">
                      SKU starts with
                    </Select.Option>
                    {enableSN && (
                      <Select.Option value="serialNumber">S/N Equals</Select.Option>
                    )}
                    {/* <Select.Option value="ProductTitle">
                      Title starts with
                    </Select.Option> */}
                    <Select.Option value="productTitleContains">
                      Product Name
                    </Select.Option>
                    <Select.Option value="divisionCode">
                      Division Code
                    </Select.Option>
                    <Select.Option value="departmentCode">
                      Department Code
                    </Select.Option>
                    <Select.Option value="groupCode">Group Code</Select.Option>
                    <Select.Option value="subGroupCode">
                      Subgroup Code
                    </Select.Option>
                    {lotEnable && (
                      <Select.Option value="lotNumber">
                        LOT#
                      </Select.Option>
                    )}
                    <Select.Option value="skus">
                      SKU/UPC List
                    </Select.Option>
                  </Select>
                }
              >
                <Input
                  allowClear
                  disabled={selectedWarehouseNums.length === 0}
                  className="group-compact-right form-input400"
                  onChange={(val) => setProductSearchKeyword(val.target.value)}
                  onBlur={(val) =>
                    setProductSearchKeyword(val.target.value.trim())
                  }
                  onClick={()=>{
                    if(productSearchType === 'skus'){
                      setListSkuInputVisible(true)
                    }
                  }}
                  placeholder=""
                  value={productSearchKeyword}
                />
              </Form.Item>
            </FormCol>
              <Form.Item style={{ marginRight: '20px' }} labelCol={{ style: { width: '110px'} }} label={<FormLabel>Inventory Type</FormLabel>}>
                <Select style={{width: '100%', minWidth: 160}} value={skuType} onChange={setSkuType} allowClear>
                  {/*Object.keys(skuTypeKeyValue).sort().map(item=>{
                    return <Select.Option value={Number(item)} key={item}>{skuTypeKeyValue[item]}</Select.Option>
                  })*/}
                  {Object.keys(skuTypeKeyValue).map(val => ({k: skuTypeKeyValue[val], v: val})).sort((a, b) => a.k.localeCompare(b.k)).map(e => {
                    return <Select.Option value={Number(e.v)} key={`${e.k}-${e.v}`}>{e.k}</Select.Option>
                  })}
                </Select>
              </Form.Item>
            <Col>

            </Col>
              <Form.Item style={{ marginRight: '20px' }} labelCol={{ style: { width: '110px'} }} label={<FormLabel>Bundle Type</FormLabel>}>
                <Select style={{width: '100%', minWidth: 160}} value={bundleType} onChange={setBundleType} allowClear>
                  <Select.Option value={-1}>All</Select.Option>
                  <Select.Option value={4}>Assembled SKU</Select.Option>
                  {/* <Select.Option value={1}>Bundle SKU</Select.Option> */}
                  <Select.Option value={2}>Prepack SKU</Select.Option>
                  <Select.Option value={0}>Regular SKU</Select.Option>
                </Select>
              </Form.Item>
            <Col>

            </Col>
              <Form.Item style={{ marginRight: '20px' }} labelCol={{ style: { width: '80px' } }} label={<FormLabel>Customer</FormLabel>}>
              <Select
                  showSearch
                  allowClear
                  value={customerCode}
                  onChange={setCustomerCode}
                  style={{ width: '100%', minWidth: 120 }}
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (option) {
                      const { children = '', value = '' } = option;
                      return (typeof children === 'string' && children.toLowerCase().indexOf(input.toLowerCase()) >= 0)
                        || (typeof value === 'string' && value.toLowerCase().indexOf(input.toLowerCase()) >= 0)
                    }

                    return false;
                  }}
                >
                  {customers.sort((a, b) => a.customerName.localeCompare(b.customerName)).map(item =>
                    <Select.Option key={item.customerCode} value={item.customerCode}>
                      {item.customerName}
                    </Select.Option>

                  )}
                </Select>
              </Form.Item>
            <Col>
            
            </Col>
            {lotEnable && setttingInited && <Col>
              <Form.Item style={{ marginRight: '20px' }} labelCol={{ style: { width: '90px' } }} label={<FormLabel>First in Date</FormLabel>}>
              <RangePicker
                    allowClear
                    style={{ width: '100%' }}
                    format="MM/DD/YYYY"
                    value={firstIn}
                    onChange={setFirstIn}
                    ranges={{
                      Today: [moment().startOf('day'), moment().endOf('day')],
                      Yesterday: [
                        moment().add(-1, 'day').startOf('day'),
                        moment().add(-1, 'day').endOf('day'),
                      ],
                      '2 days ago': [
                        moment().add(-2, 'day').startOf('day'),
                        moment().endOf('day'),
                      ],
                      '3 days ago': [
                        moment().add(-3, 'day').startOf('day'),
                        moment().endOf('day'),
                      ],
                      'This Week': [
                        moment().startOf('week'),
                        moment().endOf('week'),
                      ],
                      'Last Week': [
                        moment().add(-1, 'week').startOf('week'),
                        moment().add(-1, 'week').endOf('week'),
                      ],
                      'This Month': [
                        moment().startOf('month'),
                        moment().endOf('month'),
                      ],
                    }}
                  />
                  </Form.Item>
            </Col>}
            {lotEnable && setttingInited && <Col>
              <Form.Item style={{ marginRight: '20px' }} labelCol={{ style: { width: '110px' } }} label={<FormLabel>Expiration Date</FormLabel>}>
              <RangePicker
                    allowClear
                    style={{ width: '100%' }}
                    value={expiration}
                    onChange={setExpiration}
                    format="MM/DD/YYYY"
                    ranges={{
                      Today: [moment().startOf('day'), moment().endOf('day')],
                      Yesterday: [
                        moment().add(-1, 'day').startOf('day'),
                        moment().add(-1, 'day').endOf('day'),
                      ],
                      '2 days ago': [
                        moment().add(-2, 'day').startOf('day'),
                        moment().endOf('day'),
                      ],
                      '3 days ago': [
                        moment().add(-3, 'day').startOf('day'),
                        moment().endOf('day'),
                      ],
                      'This Week': [
                        moment().startOf('week'),
                        moment().endOf('week'),
                      ],
                      'Last Week': [
                        moment().add(-1, 'week').startOf('week'),
                        moment().add(-1, 'week').endOf('week'),
                      ],
                      'This Month': [
                        moment().startOf('month'),
                        moment().endOf('month'),
                      ],
                    }}
                  />
                  </Form.Item>
            </Col>}
            <Col>
              <Form.Item style={{ marginRight: '20px' }} labelCol={{ style: { width: '130px' } }} label={<FormLabel>Product Status</FormLabel>}>
                <Select
                  value={productStatus}
                  dropdownMatchSelectWidth={false}
                  onChange={(value: number) => setProductStatus(value)}
                >
                  <Select.Option value={-1}>All</Select.Option>
                  <Select.Option value={0}>Active</Select.Option>
                  <Select.Option value={1}>Archive</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col>
              <Space>
                <Checkbox
                  style={{ marginLeft: '20px' }}
                  defaultChecked={true}
                  onChange={(e) => setHideZero(e.target.checked)}
                >
                  Hide Zero Quantity Item
                </Checkbox>
                <Button
                  type="primary"
                  disabled={selectedWarehouseIds.length === 0}
                  onClick={() => {
                    setParamSkip(0)
                    handleSearchProduct();
                  }}
                  className="ant-search-btn"
                >
                  <SearchOutlined />
                  Search
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </GreyCardWrapper>
      {productLoaded ? (
        <Row align="middle" justify="space-between" style={{ marginTop: REGULAR_SECTION_INNER_VERTICAL_SPACING }}>
          <Col>
            <TablesFilter
              dataSource={productList}
              setFilteredData={setFilteredData}
              columns={columns}
              inputProps={{ width: 220 }}
            />
          </Col>
          <Col>
            <StatisticColumns />
          </Col>
          <Col className="space-ctn">
            <ExportCSV
              columns={columns.filter((column) => {
                if (
                  column.header === 'Action' ||
                  column.header === 'Picture' ||
                  !column.header
                ) {
                  return false;
                }
                return true;
              })}
              disabled={productList.length === 0}
              data={productList}
              formatColumns={{
                productStatus: {
                  0: 'Active',
                  1: 'Archive'
                },
                condition: conditionEmun
              }}
              showGroupBy
              scope="products"
              downloadFromApi={(data, groupBy) => downLoadAll(data, groupBy)}
            />
            {createMoreActionButton()}
          </Col>
        </Row>
      ) : (
        ''
      )}
      {productLoaded ? (<div className="grid-ctn">
        <DataGridPlus
          cacheKey={DATAGRID_CACHE_INVENTORY_SEARCH_COLS}
          showScrollButton
          columns={columns}
          dataSource={filteredData}
          idProperty="sku"
          autoWith={false}
          skip={paramSkip}
          limit={DEFAULT_LIST_ROW_NUM}
          loading={isLoadingProductList}
          pagination
          pageSizes={[10, 20, 50, 100, 200, 500]}
          checkboxColumn
          count={count}
          onChange={(limit, skip) => {
            if (limit === paramLimit && skip === paramSkip) return;
            setParamLimit(limit);
            setParamSkip(skip);
            getWarehouseProductList(
              selectedWarehouseNums[0],
              selectedWarehouseIds[0],
              skip,
              limit,
              getProductSearchFilter(productSearchType, productSearchKeyword)
            );
          }}
          onSelectionChange={(props) =>
            onSelectionChange(
              props,
              filteredData,
              setSelected,
              setSelectedRows,
              "sku"
            )
          }
          selected={selected}
          // onSortInfoChange={async (v: any) => {
          //   if (v) {
          //     if (v.dir === 1) {
          //       sortString.current = `${v.id} asc`;
          //       getWarehouseProductList(
          //         selectedWarehouseNums[0],
          //         selectedWarehouseIds[0],
          //         paramSkip,
          //         paramLimit,
          //         getProductSearchFilter(
          //           productSearchType,
          //           productSearchKeyword
          //         )
          //       );
          //     }
          //     if (v.dir === -1) {
          //       sortString.current = `${v.id} desc`;
          //       getWarehouseProductList(
          //         selectedWarehouseNums[0],
          //         selectedWarehouseIds[0],
          //         paramSkip,
          //         paramLimit,
          //         getProductSearchFilter(
          //           productSearchType,
          //           productSearchKeyword
          //         )
          //       );
          //     }
          //   } else {
          //     sortString.current = 'sku asc';
          //     getWarehouseProductList(
          //       selectedWarehouseNums[0],
          //       selectedWarehouseIds[0],
          //       paramSkip,
          //       paramLimit,
          //       getProductSearchFilter(productSearchType, productSearchKeyword)
          //     );
          //   }
          // }}
          //style={{ height: gridHeight }}
          style={{ height: 'auto', minHeight: 'none' }}
          {...({} as any)}
        />
      </div>) : // </Row>
        isLoadingProductList && (<div className="search-list-empty-space">
          <Row align="middle" justify="center" style={{ height: '100%' }}>
            <Loading color="#006dff" size={48} />
          </Row>
        </div>)
      }
      {
        listSkuInputVisible && (
          <InputSkuListDialog
            visible={true}
            onHide={() => setListSkuInputVisible(false)}
            onApply={(data)=>{
              setProductSearchKeyword(data)
              setListSkuInputVisible(false)
            } }
            defaultValue=''
          />
        )
      }
    </SearchListGridWrapper>
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
}
